
    import { createSlice, PayloadAction } from '@reduxjs/toolkit'
    
    type TMappingState =  {
        data: [],
        perPage: number,
        currentPage: number,
        totalPage: number,
        searchTerm: string,
        loading: boolean,
        sortBy: string,
        sortColumn:string,
        rerender1:boolean,
        mappingRender:boolean,
    }
    
    
    const initialMappingState: TMappingState = {
        data: [],
        perPage: 10,
        currentPage: 1,
        totalPage: 5,
        searchTerm: "",
        loading: false,
        sortBy: "desc",
        sortColumn:"",
        rerender1:false,
        mappingRender:false,
    
        
    }
    
    export const mappingSlice = createSlice({
        name: 'mapping',
        initialState:initialMappingState,
        reducers: {
            setMapping: (state:TMappingState, { payload }: PayloadAction<[]>) => {
              state.data=payload
             },
            setPerPage: (state:TMappingState, {payload}: PayloadAction<number>) => {
                state.perPage = payload;
            },
            setCurrentPage: (state:TMappingState, {payload}: PayloadAction<number>) => { 
                state.currentPage = payload;
            },
            setTotalPage: (state:TMappingState, {payload}: PayloadAction<number>) => { },
            setSearchTerm: (state:TMappingState, {payload}: PayloadAction<string>) => { 
                state.searchTerm = payload;
            },
            setSortBy: (state:TMappingState, {payload}: PayloadAction<string>) => { 
              state.sortBy = payload;
          },
          setSortColumn: (state:TMappingState, {payload}: PayloadAction<string>) => { 
            state.sortColumn = payload;
            state.sortBy = "desc";
        },
            setLoading: (state:TMappingState, {payload}: PayloadAction<boolean>) => { 
              state.loading = payload
            },
            setRerender: (state:TMappingState, {payload}: PayloadAction<boolean>) => {
                state.rerender1 = payload
             },
             setMappingRerender: (state:TMappingState, {payload}: PayloadAction<boolean>) => {
                state.mappingRender = payload
             },
        },
    })
    
    
    export const { setMapping, setPerPage, setCurrentPage, setSortColumn,setSortBy, setTotalPage, setSearchTerm, setLoading,setRerender,setMappingRerender } = mappingSlice.actions
    export default mappingSlice.reducer
    